import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

// Home: redirect to the first root page if there is one, otherwise show an empty state.

export function Home() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ['tree'],
    queryFn: () => api.getTree(),
  });

  useEffect(() => {
    if (!data) return;
    const firstRoot = data.pages
      .filter((p) => !p.parent)
      .sort((a, b) => a.sortOrder - b.sortOrder)[0];
    if (firstRoot) {
      navigate(`/p/${firstRoot.id}`, { replace: true });
    }
  }, [data, navigate]);

  if (isLoading) return <div className="p-12 text-brand-500">Loading…</div>;
  if (data && data.pages.length === 0) {
    return (
      <div className="p-12 max-w-2xl">
        <h1 className="text-3xl font-display text-brand-800 mb-4">Welcome to Redwood Wiki</h1>
        <p className="text-brand-700 mb-2">
          There are no pages yet. Once you create one (or run the Notion import), it will appear here.
        </p>
      </div>
    );
  }
  return <div className="p-12 text-brand-500">Loading…</div>;
}
